import React from 'react';
import PropTypes from 'prop-types';
import { Col } from 'react-bootstrap5';

import { useContext as useUsersContext } from 'components/Users/Context';

import Icon from './Icon';

export default function Tile({
  variant, title, additivePolicy, children,
}) {
  const { state: stateUser } = useUsersContext();
  const brandingAvailable = stateUser.user?.attributes?.branding_available;

  let className = 'policy-professional';
  let subtitle = 'Pay-as-you-go Coaching';

  if (title.includes('Enterprise')) {
    className = 'policy-enterprise';
    subtitle = 'Unlimited Coaching';
  } else if (title.includes('Executive')) {
    className = 'policy-executive';
  } else if (title.includes('Platform')) {
    className = 'policy-platform';
    subtitle = 'Talent Intelligence';
  }

  return (
    <Col md="6" lg="3" className="mb-4 mb-lg-0">
      <div className={`
        policy-tile ${className} policy-${brandingAvailable ? 'primary' : variant}
        d-flex flex-column h-100 p-3 border rounded-4
      `}
      >
        <header className="text-center">
          <div className=" mx-auto mb-3">
            <Icon variant={brandingAvailable ? 'primary' : variant} />
          </div>

          <h4>{title}</h4>

          <small className="fw-light">
            {subtitle}
          </small>
        </header>

        {additivePolicy ? (
          <div className="icon-with-text">
            <div className="text-content m-0 flex-fill">
              <hr className={`
                border border-${brandingAvailable ? 'primary' : variant} border-3 rounded-pill opacity-100
              `}
              />
            </div>

            <i className="small-icon plus-icon mx-2" />

            <div className="text-content m-0 flex-fill">
              <hr className={`
                border border-${brandingAvailable ? 'primary' : variant} border-3 rounded-pill opacity-100
              `}
              />
            </div>
          </div>
        ) : (
          <hr className={`
            border border-${brandingAvailable ? 'primary' : variant} border-3 rounded-pill opacity-100
          `}
          />
        )}

        <span className="fw-semibold">Overview</span>

        {children}
      </div>
    </Col>
  );
}

Tile.propTypes = {
  variant: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  additivePolicy: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

Tile.defaultProps = {
  additivePolicy: false,
};
